import isNull from 'lodash/isNull'

export const getAccountName = (firstName, lastName) => {
  if (isNull(firstName)) {
    firstName = ''
  }
  if (isNull(lastName)) {
    lastName = ''
  }
  return `${firstName} ${lastName}`
}
